import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Connect from '../views/Connect.vue'
import Settings from '../views/Settings.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/connections',
    name: 'Connections',
    component: () => import(/* webpackChunkName: "about" */ '../views/Connections.vue')
  },
  {
    path: '/requests',
    name: 'Requests',
    component: () => import(/* webpackChunkName: "about" */ '../views/Requests.vue')
  },
  {
    path: '/locations',
    name: 'Locations',
    component: () => import(/* webpackChunkName: "about" */ '../views/Locations.vue')
  },
  {
    path: '/c/:link',
    name: 'Connect',
    //component: () => import(/* webpackChunkName: "about" */ '../views/Connect.vue')
    component: Connect
  },
  {
    path: '/p/:link',
    name: 'Connect',
    //component: () => import(/* webpackChunkName: "about" */ '../views/Connect.vue')
    component: Connect
  },
  {
    path: '/c',
    name: 'Connect',
    //component: () => import(/* webpackChunkName: "about" */ '../views/Connect.vue')
    component: Connect
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/help/:section',
    name: 'Help',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Help.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue')
    component: Settings
  },
  {
    path: '/settings/:link',
    name: 'Settings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue')
    component: Settings
  },
  {
    path: '/graph',
    name: 'Graph',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Graph.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
